import angular from 'angular';
import LegalNotice from '../data/legal-notice.data';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalNoticeDA', LegalNoticeDA);

    LegalNoticeDA.$inject = ['Restangular', 'CONF', '$translate'];

    /**
     * Classe permettant la manipulation des infos relatives aux mentions légales.
     */

    /* @ngInject */
    function LegalNoticeDA(Restangular, CONF, $translate) {
        var baseUrl = CONF.apiBaseUrl + '/v1/legal-notices';

        var exports = {
            getLegalNotices: getLegalNotices,
            saveLegalNotices: saveLegalNotices
        };

        return exports;
        
        /**
         * Récupère les mentions légales de la communauté.
         * @param communityEid - l'identifiant de la communauté à laquelle les mentions légales sont rattachées.
         */
         function getLegalNotices(communityEid) {
            return Restangular.one(baseUrl + '/' + communityEid + '/community')
                .get()
                .then(function (data) {
                    return new LegalNotice(data, $translate);
                });
        }

        /**
         * Sauvegarde des mentions légales.
         * @param legalNotice - les mentions légales.
         */
         function saveLegalNotices(legalNotice) {
            return Restangular.all(baseUrl + '/create').post(legalNotice);
        }

    }
})();
